import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { isEmpty } from 'class-validator';
import { BasicResponse } from 'src/app/core/models/basic-response.model';
import { getErrorMessage, hideSpinner, showSpinner } from 'src/app/core/services/functions.service';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { RolesService } from '../../../../modulos/services/roles.service';

@Component({
  selector: 'app-usuarios-roles',
  templateUrl: './usuarios-roles.component.html',
  styleUrls: ['./usuarios-roles.component.scss']
})
export class UsuariosRolesComponent implements OnInit {

  roles: any[] = []
  rolesToDelete: any[] = []
  rolesToAssign: any[] = []
  selectedRolesToAssign: any[] = []
  selectedRolesToDelete: any[] = []

  userRoles: any[] = []

  constructor(
    private helpers: HelpersService,
    private rolesService: RolesService,
    @Inject(MAT_DIALOG_DATA) public usuario_aplicativo: string
  ) {
    if (isEmpty(this.usuario_aplicativo)) {
      throw new Error("No se puede desplegar esta opcion sin un usuario seleccionado");
    }

  }

  async ngOnInit() {
    await this.getAllRoles()
    await this.getAllUserRoles()
    this.setRolesToAssign()
    this.setRolesToDelete()
  }

  async getAllUserRoles() {
    this.userRoles = []
    showSpinner()
    try {
      const result = await this.rolesService.findAllByUser(this.usuario_aplicativo)
      if (result.success) {
        this.userRoles = result.data
      } else {
        this.helpers.notifications.errorMessage(result.message)
      }
    } catch (error) {
      const message = getErrorMessage(error)
      this.helpers.notifications.errorMessage(message)
    }
    hideSpinner()
  }

  async getAllRoles() {
    this.roles = []
    showSpinner()
    try {
      const result = await this.rolesService.findAll()
      if (result.success) {
        this.roles = result.data
      } else {
        this.helpers.notifications.errorMessage(result.message)
      }
    } catch (error) {
      const message = getErrorMessage(error)
      this.helpers.notifications.errorMessage(message)
    }
    hideSpinner()
  }

  async asignarRoles() {
    showSpinner()
    if (this.selectedRolesToAssign.length > 0 && this.usuario_aplicativo) {
      try {
        const result = await this.rolesService.asignarRolesAlUsuario(this.usuario_aplicativo, this.selectedRolesToAssign.map(val => val.codigo))
        if (result.success) {
          await this.getAllUserRoles()
          this.setRolesToAssign()
          this.setRolesToDelete()
          this.selectedRolesToAssign = []
          this.selectedRolesToDelete = []
          this.helpers.notifications.successMessage(result.message)
        } else {
          this.helpers.notifications.errorMessage(result.message)
        }
      } catch (error) {
        const message = getErrorMessage(error)
        this.helpers.notifications.errorMessage(message)
      }
    } else {
      this.helpers.notifications.errorMessage("Debe seleccionar por lo menos un rol")
    }
    hideSpinner()
  }

  async eliminarRoles() {
    showSpinner()
    if (this.selectedRolesToDelete.length > 0 && this.usuario_aplicativo) {
      try {
        const result = await this.rolesService.eliminarRolesDelUsuario(this.usuario_aplicativo, this.selectedRolesToDelete.map(val => val.codigo))
        if (result.success) {
          await this.getAllUserRoles()
          this.setRolesToAssign()
          this.setRolesToDelete()
          this.selectedRolesToAssign = []
          this.selectedRolesToDelete = []
          this.helpers.notifications.successMessage(result.message)
        } else {
          this.helpers.notifications.errorMessage(result.message)
        }
      } catch (error) {
        const message = getErrorMessage(error)
        this.helpers.notifications.errorMessage(message)
      }
    } else {
      hideSpinner()
      this.helpers.notifications.errorMessage("Debe seleccionar por lo menos un rol")
    }
    hideSpinner()
  }


  setRolesToAssign() {
    this.rolesToAssign = this.excludeRoles(this.roles, this.userRoles)
  }

  setRolesToDelete() {
    this.rolesToDelete = this.getThisRoles(this.roles, this.userRoles)
  }

  excludeRoles(array: any[], toRemove: any[]) {
    const result = array.filter(value => {
      const find = toRemove.find(val => value.codigo == val.codigo)
      return find == undefined;
    });
    return result
  }


  getThisRoles(array: any[], toGet: any[]) {
    const result = array.filter(value => {
      const find = toGet.find(val => value.codigo == val.codigo)
      return find != undefined;
    });
    return result
  }

}
